export const PRODUCTS_PAGE_SIZE = 500;
